export enum FILTER_TYPES {
  Hierarchy = 'Hierarchy',
  Simple = 'Simple',
}
